import { useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';

import { MenuContext } from '../../contexts/ui.context';

import MenuSVG from '../../vectors/menu.svg';
import { TreeContainer } from "./tree-logo.styles";


const TreeLogo = ({bg}) => {
	const { setCurrentMenu } = useContext(MenuContext);

	const toggleMenu = () => {
		setCurrentMenu(true);
	};

	return(
		<TreeContainer color={bg}>
			<span className='tree'>
				<Link to={"../"} 
						style={{ 
							color: 'inherit',
							textDecoration: 'inherit',
							width: '100%',
							height: '100%',
							display: 'flex',
							alignItems: 'center',
					}} >
						TREE
				</Link>
			</span>
			<MenuSVG onClick={toggleMenu} />
		</TreeContainer>
				
	);
}

export default TreeLogo;